import { Component } from 'react';
import { connect } from 'react-redux';

import { CheckoutLayout } from 'common/components/layout';
import Footer from 'common/components/layout/Footer';
import { checkoutStep } from 'redux/reservationCart/actions';

import EditStep from './EditStep';
import ContentSummary from './components/ContentSummary';
import Header from './components/Header';
import Message from './components/Message';
import MobileToggleSummary from './components/MobileToggleSummary';
import ReservationSummary from './components/ReservationSummary';
import { calculateStep, editStep } from './helpers';

class Checkout extends Component {
  constructor(props) {
    super(props);
    const step = calculateStep(props.reservationCart);
    this.state = {
      isSummaryVisibleOnMobile: false,
      step
    };
    if (props.reservationCart.data) {
      props.checkoutStep(step);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { props } = this;
    if (nextProps.reservationCart.data && !props.reservationCart.data) {
      const step = calculateStep(nextProps.reservationCart);
      this.setState({ step }, () => {
        if (nextProps.reservationCart.data) {
          props.checkoutStep(step, nextProps.reservationCart.data);
        }
      });
    }
  }

  // componentDidUpdate(prevProps) {
  //   const { props } = this;

  // if (!prevProps.cart.data && props.cart.data) {
  //   if (props.cart.data.items.length === 0) {
  //     // no cart items, so we redirect
  //     props.history.push('/cart');
  //   }
  // }
  // }

  handleEdit = (step) => {
    const { props } = this;
    const newStep = editStep(props.reservationCart, step);
    this.setState({ step: newStep }, () => {
      props.checkoutStep(newStep);
    });
  };

  toggleMobileSummary = () => {
    const { isSummaryVisibleOnMobile } = this.state;
    this.setState({ isSummaryVisibleOnMobile: !isSummaryVisibleOnMobile });
  };

  render() {
    const { settings, reservationCart, customer } = this.props;
    const { isSummaryVisibleOnMobile } = this.state;
    const { step } = this.state;
    if (!settings.data || !reservationCart.data) {
      return (
        <CheckoutLayout title="Reservation Checkout" loading>
          &nbsp;
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Reservation Checkout">
        <MobileToggleSummary onToggleMobile={this.toggleMobileSummary} />
        <div className="c7-checkout">
          <ReservationSummary
            reservationCart={reservationCart.data}
            isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
            settings={settings}
          />
          <div className="c7-checkout__main">
            <Header
              settings={settings}
              step={step}
              onMenuClick={this.handleEdit}
            />
            <div className="c7-checkout__content">
              <Message settings={settings} />
              <ContentSummary
                reservationCart={reservationCart.data}
                customer={customer.data}
                onEdit={this.handleEdit}
                currentStep={step}
              />
              <EditStep
                reservationCart={reservationCart.data}
                customer={customer.data}
                step={step}
                onEdit={this.handleEdit}
              />
            </div>
            <Footer settings={settings} />
          </div>
        </div>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  reservationCart: state.reservationCart,
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { checkoutStep })(Checkout);
